export default {
  props: {
    title: "Props",
  },
};